import React, { Component } from 'react';
import { obfuscatedCoordinates } from '../../util/maps';
import { Map } from '../../components';

import css from './LocationMap.module.css';

/**
 * LocationMap component - displays a map without heading
 *
 * @component
 * @param {Object} props
 * @param {propTypes.latlng} [props.geolocation] - The geolocation
 * @param {Object} [props.publicData] - Public data containing location info
 * @param {propTypes.uuid} props.listingId - The listing id
 * @param {Object} props.mapsConfig - Maps configuration
 * @returns {JSX.Element} location map component
 */
class LocationMap extends Component {
  constructor(props) {
    super(props);
    this.state = { isStatic: false };
  }

  render() {
    const { geolocation, publicData, listingId, mapsConfig } = this.props;

    if (!geolocation) {
      return null;
    }

    const address = publicData && publicData.location ? publicData.location.address : '';
    const cacheKey = listingId ? `${listingId.uuid}_${geolocation.lat}_${geolocation.lng}` : null;

    const mapProps = mapsConfig.fuzzy.enabled
      ? { obfuscatedCenter: obfuscatedCoordinates(geolocation, mapsConfig.fuzzy.offset, cacheKey) }
      : { address, center: geolocation };
    const map = (
      <Map
        {...mapProps}
        useStaticMap={this.state.isStatic}
        rootClassName={css.mapRoot}
        mapRootClassName={css.mapInner}
      />
    );

    return (
      <div className={css.locationMapContainer}>
        {this.state.isStatic ? (
          <button
            className={css.mapButton}
            onClick={() => {
              this.setState({ isStatic: false });
            }}
          >
            {map}
          </button>
        ) : (
          <div className={css.mapWrapper}>{map}</div>
        )}
      </div>
    );
  }
}

export default LocationMap;
